import { createTheme } from '@mui/material/styles';

const baseTheme = {
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-4px)',
          },
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: '16px',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '16px',
          '&:last-child': {
            paddingBottom: '16px',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h4: {
          fontSize: '1.5rem',
          fontWeight: 600,
          letterSpacing: '0.02em',
        },
        h6: {
          fontSize: '1.1rem',
          fontWeight: 600,
        },
      },
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
};

const darkTheme = {
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#9d65cc',
      light: '#b586db',
      dark: '#7b4fa3',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
  },
};

const lightTheme = {
  ...baseTheme,
  palette: {
    mode: 'light',
    primary: {
      main: '#652991',
      light: '#8547ad',
      dark: '#461d64',
    },
    background: {
      default: '#f4f4f4',
      paper: '#ffffff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
  },
};

export const getTheme = (mode = 'light') => 
  createTheme(mode === 'dark' ? darkTheme : lightTheme);

// import { createTheme } from '@mui/material/styles';

// const baseTheme = {
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           transition: 'box-shadow 0.3s ease, transform 0.3s ease',
//         },
//       },
//     },
//   },
// };

// const darkTheme = {
//   ...baseTheme,
//   palette: {
//     mode: 'dark',
//     primary: {
//       main: '#9d65cc', // Lighter purple for dark theme
//       light: '#b586db',
//       dark: '#7b4fa3',
//     },
//     text: {
//       primary: '#ffffff',
//       secondary: 'rgba(255, 255, 255, 0.7)',
//     },
//     background: {
//       default: '#121212',
//       paper: '#1e1e1e',
//     },
//   },
// };

// const lightTheme = {
//   ...baseTheme,
//   palette: {
//     mode: 'light',
//     primary: {
//       main: '#652991',
//       light: '#8547ad',
//       dark: '#461d64',
//     },
//     text: {
//       primary: 'rgba(0, 0, 0, 0.87)',
//       secondary: 'rgba(0, 0, 0, 0.6)',
//     },
//     background: {
//       default: '#f4f4f4',
//       paper: '#ffffff',
//     },
//   },
// };

// export const getTheme = (mode = 'light') => 
//   createTheme(mode === 'dark' ? darkTheme : lightTheme);












// import { createTheme } from '@mui/material/styles';
// const defaultMode = 'light';


// // src/theme/index.js
// export const getTheme = (mode = defaultMode) => createTheme({
//   palette: {
//     mode: 'dark',
//     primary: {
//       main: '#652991',
//     },
//     secondary: {
//       main: '#f6b312',
//     },
//     background: {
//       default: '#121212',
//       paper: '#1e1e1e',
//     },
//   },
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           border: '1px solid rgba(255, 255, 255, 0.12)',
//           boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
//           '&:hover': {
//             boxShadow: '0 6px 12px rgba(0, 0, 0, 0.4)',
//           },
//         },
//       },
//     },
//     MuiCardHeader: {
//       styleOverrides: {
//         root: {
//           borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
//           backgroundColor: 'rgba(255, 255, 255, 0.05)',
//         },
//       },
//     },
//     MuiTypography: {
//       styleOverrides: {
//         h4: {
//           fontWeight: 600,
//           fontSize: '1.75rem',
//           marginBottom: '1.5rem',
//           paddingBottom: '0.5rem',
//           borderBottom: '2px solid #652991',
//         },
//         h5: {
//           fontWeight: 600,
//           fontSize: '1.25rem',
//           marginBottom: '1rem',
//         },
//       },
//     },
//   },
// });


// // export const getTheme = (mode = defaultMode) => createTheme({
// //   palette: {
// //     mode,
// //     primary: {
// //       main: '#652991',
// //     },
// //     secondary: {
// //       main: '#f6b312',
// //     },
// //     background: {
// //       default: mode === 'dark' ? '#121212' : '#f4f4f4',
// //       paper: mode === 'dark' ? '#1e1e1e' : '#ffffff',
// //     },
// //   },
// // });


// // // src/theme/index.js
// // import { createTheme } from '@mui/material/styles';

// // export const theme = createTheme({
// //   palette: {
// //     primary: {
// //       main: '#652991',
// //       light: '#8547ad',
// //       dark: '#461d64',
// //     },
// //     secondary: {
// //       main: '#f6b312',
// //       light: '#ffc340',
// //       dark: '#c48900',
// //     },
// //     error: {
// //       main: '#e30613',
// //     },
// //     warning: {
// //       main: '#f6b312',
// //     },
// //     success: {
// //       main: '#10B981',
// //     },
// //     background: {
// //       default: '#f4f4f4',
// //       paper: '#ffffff',
// //     },
// //   },
// //   typography: {
// //     fontFamily: '"Arial", "Helvetica", sans-serif',
// //     h1: {
// //       fontSize: '1.5rem',
// //       fontWeight: 600,
// //     },
// //     h2: {
// //       fontSize: '1.25rem',
// //       fontWeight: 600,
// //     },
// //     h3: {
// //       fontSize: '1.125rem',
// //       fontWeight: 600,
// //     },
// //   },
// //   components: {
// //     MuiCard: {
// //       styleOverrides: {
// //         root: {
// //           borderRadius: 8,
// //           boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
// //           transition: 'box-shadow 0.3s ease',
// //           '&:hover': {
// //             boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
// //           },
// //         },
// //       },
// //     },
// //     MuiButton: {
// //       styleOverrides: {
// //         root: {
// //           textTransform: 'none',
// //           borderRadius: 6,
// //         },
// //       },
// //     },
// //     MuiChip: {
// //       styleOverrides: {
// //         root: {
// //           borderRadius: 6,
// //         },
// //       },
// //     },
// //   },
// // });

// // // Create dark theme variant
// // export const darkTheme = createTheme({
// //   ...theme,
// //   palette: {
// //     ...theme.palette,
// //     mode: 'dark',
// //     background: {
// //       default: '#1a1a1a',
// //       paper: '#2d2d2d',
// //     },
// //   },
// // });